import Vue from 'vue'
import './vuetify'
import App from './App.vue'
import VueRouter from './router'
import store from './store'
import Vuex from 'vuex'
import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import VueSession from 'vue-session'
import i18n from './i18n'
import globalVar from './GlobalVar.js'

import VueCookies from 'vue-cookies'
import Croppa from 'vue-croppa'
import 'vue-croppa/dist/vue-croppa.css'

Vue.use(Croppa)
Vue.use(VueCookies)

//VueCookies.config('Infinity')
Vue.$cookies.config('7d')
Vue.$cookies.set('theme', 'default')
Vue.$cookies.set('hover-time', '1s')

// import Login from './Login.vue'
// import Register from './Register.vue'
// import Search from './Search.vue'
// import Testing from './testing.vue'
// import MainList from './MainList.vue'
import Header from './Header.vue'

Vue.config.productionTip = false

Vue.use(Vuex)
Vue.use(BootstrapVue)
Vue.use(Vuetify)
Vue.use(require('vue-moment'))
Vue.use(VueSession, { persist: true })

// Vue.component('app-login', Login)
// Vue.component('app-register', Register)
// Vue.component('app-search', Search)
// Vue.component('app-testing', Testing)
// Vue.component('app-mainList', MainList)
Vue.component('app-header', Header)

VueRouter.beforeEach((to, from, next) => {
  if (Vue.$cookies.get('lang') != null) {
    let language = Vue.$cookies.get('lang')
    // console.log('language:', language)
    // if (!language) {
    //   language = 'en-us'
    // }
    i18n.locale = language
  } else {
    let language = 'en-us'
    i18n.locale = language
  }

  if (to.matched.some(record => record.meta.authenticated)) {
    console.log(to.matched.some(record => record.meta.authenticated))
    // alert('check!')

    const key = 'isSearched'
    if (sessionStorage.getItem(key)) {
      const value = sessionStorage.getItem(key)
      // console.log(value)
      var searchedResult = JSON.parse(value)
      // console.log(searchedResult)
    }

    // console.log('searchedResult', searchedResult)
    var mchCd = sessionStorage.getItem('paramMchdCode')
    if (searchedResult == undefined) {
      if (globalVar.mode == 'normal') {
        next({
          path: '/'
        })
      } else if (globalVar.mode == 'lite') {
        next({
          name: 'NotFound',
          params: {
            mchdCode: mchCd
          }
        })
      }
    } else {
      if (
        to.matched.some(record => record.meta.authenticated) ==
        searchedResult.search
      ) {
        // alert('match')
        if (to.path == '/Backend') {
          if (sessionStorage.getItem('isLoginedBackEnd')) {
            const value = sessionStorage.getItem('isLoginedBackEnd')
            var backEndStatus = JSON.parse(value)
            if (backEndStatus == undefined) {
              if (globalVar.mode == 'normal') {
                next({
                  path: '/'
                })
              } else if (globalVar.mode == 'lite') {
                next({
                  name: 'NotFound',
                  params: {
                    mchdCode: mchCd
                  }
                })
              }
            } else {
              if (
                to.matched.some(record => record.meta.authenticated) ==
                backEndStatus.backEnd
              ) {
                next()
              } else {
                if (globalVar.mode == 'normal') {
                  next({
                    path: '/'
                  })
                } else if (globalVar.mode == 'lite') {
                  next({
                    name: 'NotFound',
                    params: {
                      mchdCode: mchCd
                    }
                  })
                }
              }
            }
          } else {
            if (globalVar.mode == 'normal') {
              next({
                path: '/'
              })
            } else if (globalVar.mode == 'lite') {
              next({
                name: 'NotFound',
                params: {
                  mchdCode: mchCd
                }
              })
            }
          }
        } else {
          next()
        }
      } else {
        if (globalVar.mode == 'normal') {
          next({
            path: '/'
          })
        } else if (globalVar.mode == 'lite') {
          next({
            name: 'NotFound',
            params: {
              mchdCode: mchCd
            }
          })
        }
      }
    }
  } else {
    next()
  }
})

new Vue({
  store,
  i18n,
  router: VueRouter,
  render: h => h(App)
}).$mount('#app')
